import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'product_id': {
    title: '产品编码',
    type: 'input',
    equation: all,
    slot: true,
    width: 180
  },
  'short_text': {
    title: '产品描述',
    type: 'input',
    equation: all,
    width: 400
  },
  'hzps': {
    title: '盒装瓶数',
    xlsxFmt: {
      t: 'n'
    }
  },
  'xzhs': {
    title: '箱装盒数',
    xlsxFmt: {
      t: 'n'
    }
  },
  'capty': {
    title: '容量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'degree': {
    title: '度数'
  },
  'ycate': {
    describe: true,
    title: '月报分类',
    type: 'select',
    equation: city,
    dictionary: 'A0016',
    width: 150
  },
  'chfl': {
    title: '存货分类代码',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    width: 100
  },
  'chfl_text': {
    title: '存货分类描述',
    type: 'input',
    width: 150
  },
  'pcate': {
    describe: true,
    title: '产品分类',
    type: 'select',
    equation: city,
    dictionary: 'A0028'
  },
  'brand_bq': {
    describe: true,
    title: '品牌(bq)',
    type: 'select',
    equation: city,
    dictionary: 'A0018',
    width: 150
  },
  'short': {
    title: '产品简称',
    type: 'input',
    equation: all,
    width: 200
  },
  'norms': {
    title: '显示规格',
    type: 'input',
    equation: all,
    width: 200
  },
  'uname': {
    title: '创建人',
    type: 'input',
    equation: all
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'block': {
    title: '停用标识',
    type: 'input',
    equation: all
  },
  'zzfld000026': {
    title: '归档标识',
    type: 'input',
    equation: all
  },
  'nrate': {
    title: '配额内外比例(内)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    }
  },
  'wrate': {
    title: '配额内外比例(外)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    }
  },
  'pocycle': {
    title: '包材采购周期(天)',
    width: 150
  },
  'powarning': {
    title: '包材安全预警量(件)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    }
  },
  'pecycle_text': {
    title: '配额控制周期'
  },
  'brand': {
    describe: true,
    title: '品牌(生产计划)',
    type: 'select',
    equation: city,
    dictionary: 'A0015',
    width: 150
  },
  'onumb': {
    title: '老编码',
    type: 'input',
    equation: all,
    width: 150
  },
  'numbr': {
    title: '编码',
    type: 'input',
    equation: all,
    width: 150
  },
  'scate': {
    title: '小类',
    type: 'input',
    equation: all
  },
  'bcate': {
    title: '大类',
    type: 'input',
    equation: all
  },
  'bcode': {
    title: '条形码',
    type: 'input',
    equation: all
  },
  'cmade': {
    title: '是否定制',
    type: 'whether',
    equation: be
  },
  'fflag': {
    title: '全流程标识',
    type: 'input',
    equation: all
  },
  'isbar': {
    title: '是否有条形码',
    type: 'whether',
    equation: be
  },
  'isept': {
    title: '是否出口',
    type: 'whether',
    equation: be
  },
  'ispej': {
    title: '是否配额酒',
    type: 'whether',
    equation: be
  },
  'mcate': {
    title: '中类',
    type: 'input',
    equation: all
  },
  'mdate': {
    title: '更改日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'mname': {
    title: '更改者',
    type: 'input',
    equation: cusname
  },
  'updatedbyname': {
    title: '类别标识',
    type: 'input',
    equation: all
  }
}



// WEBPACK FOOTER //
// ./src/views/product-manage/config/mdmProductQuery.js